import type { ReactNode } from 'react'

import { haptic } from '../telegram'

export type TabId = 'today' | 'cycles' | 'oracle' | 'we' | 'me'

const TABS: { id: TabId; label: string; icon: ReactNode }[] = [
  {
    id: 'today',
    label: 'Сегодня',
    icon: (
      <>
        <circle cx="12" cy="12" r="8" />
        <circle cx="12" cy="12" r="2.2" fill="currentColor" stroke="none" />
      </>
    ),
  },
  {
    id: 'cycles',
    label: 'Циклы',
    // Три вложенные дуги: год в годе, круг в круге — время, которое
    // возвращается не в ту же точку. Разрывы у всех трёх смотрят в одну
    // сторону, поэтому на 23px значок читается как спираль, а не как мишень.
    icon: (
      <>
        <path d="M12 3.5a8.5 8.5 0 1 1-6 2.5" />
        <path d="M12 6.5a5.5 5.5 0 1 1-3.9 1.6" />
        <path d="M12 9.4a2.6 2.6 0 1 1-1.8 0.8" />
      </>
    ),
  },
  {
    id: 'oracle',
    label: 'Оракул',
    icon: (
      <>
        <path d="M5 7.5h14" />
        <path d="M5 12h5.6M13.4 12H19" />
        <path d="M5 16.5h14" />
      </>
    ),
  },
  {
    id: 'we',
    label: 'Мы',
    icon: (
      <>
        <circle cx="9.2" cy="12" r="5.8" />
        <circle cx="14.8" cy="12" r="5.8" />
      </>
    ),
  },
  {
    id: 'me',
    label: 'Я',
    icon: (
      <>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 7.2 16.3 12 12 16.8 7.7 12z" />
      </>
    ),
  },
]

export function TabBar({ active, onChange }: { active: TabId; onChange: (tab: TabId) => void }) {
  return (
    <nav className="tabbar">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`tab${tab.id === active ? ' active' : ''}`}
          onClick={() => {
            if (tab.id !== active) haptic('light')
            onChange(tab.id)
          }}
        >
          <svg viewBox="0 0 24 24">{tab.icon}</svg>
          <span>{tab.label}</span>
        </button>
      ))}
    </nav>
  )
}
